export default __webpack_public_path__ + "static/media/ld-2.f63c1599.jpg";